import { FC } from 'react';

import Button from '../Button';

import styles from './CodeFooter.module.css';

export type Props = {
  run: () => void;
  label: string;
  disabled?: boolean;
};

export const CodeFooter: FC<Props> = ({ label, run, disabled }) => (
  <div className={styles.root}>
    <Button
      onClick={run}
      align="end"
      size="small"
      color="primary"
      shadow="default"
      disabled={disabled}
      className={styles.button}
    >
      {label}
    </Button>
  </div>
);
